export const AP_STATUSES = {
  open: "open",
  waitListOnly: "waitlist only",
  waitList: "waitlist",
  closed: "closed"
};
